import { NumNull, StateSnapshot } from '@iotv/iotv-v3-types'

type StateMutatorFnInput = { previousVal: NumNull; timestamp?: number; iteration?: number }
export type TimeStateMutatorInput = Record<string, { val: NumNull; mutator: (stateMutatorFnInput: StateMutatorFnInput) => NumNull }>

/** given definition of how to mutate a map of values, plus  the original values, continues to return a iterated mutated version of the map */
export function* stateMutator(numberMapMutator: NumberMapMutator) {
  let err: Error | null = null
  do {
    try {
      yield numberMapMutator.getNext()
    } catch (e: any) {
      err = e
      console.log('Error in stateMutator', e.message)
    }
  } while (!err)
}

/** sets the next timestamp, based on the previous, and or the iteration sequence number eg the tiemstamp might skip 5 minutes every 10th iteration */
type TimeStamperInput = (lastTimestamp?: number, iteration?: number) => number

export type NumberMapMutatorProps = {
  /** required, initial timestamp in milliseconds */
  initialTimestamp: number
  /** how timestamp should change each call of next() */
  nextTimestampFn: TimeStamperInput
  /** how the values of each key in the map should change, based on the last value and or the timestamp */
  mutatorMap: TimeStateMutatorInput
  /** initial iteratoion - where hydrating from object store  */
  initialIteration?: number
}

/** used to inject a definition of how to modifiy a state map (of numbers or null based on timestamp, and or iteration number) into the stateMutator iterator functions */
export class NumberMapMutator {
  constructor({ initialTimestamp, nextTimestampFn, mutatorMap, initialIteration = 0 }: NumberMapMutatorProps) {
    this.currentTimestamp = initialTimestamp
    this.nextTimestampFn = nextTimestampFn
    this.mutator = mutatorMap
    this.iteration = initialIteration
  }
  iteration: number
  currentTimestamp: number
  nextTimestampFn: TimeStamperInput
  mutator: TimeStateMutatorInput
  iterate = () =>
    Object.entries(this.mutator).forEach(([k, { val, mutator }]) => {
      this.mutator[k].val = mutator({ previousVal: val, iteration: this.iteration, timestamp: this.currentTimestamp })
    })
  getValueMap = () => Object.fromEntries(Object.entries(this.mutator).map(([k, { val }]) => [k, val]))
  getNext = () => {
    this.iterate()
    const currentMap = this.getValueMap()
    this.currentTimestamp = this.nextTimestampFn(this.currentTimestamp)

    this.iteration++
    const state: StateSnapshot<NumNull> = {
      timestamp: this.currentTimestamp,
      state: currentMap,
    }
    return state
  }
}
